import routerOptions0 from "/home/runner/work/my-mr-lite/my-mr-lite/node_modules/.pnpm/nuxt@3.20.1_m27kqx52ujccnreolmnvnmopci/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/work/my-mr-lite/my-mr-lite/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}